var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServerSideResult',{attrs:{"test":_vm.transactions}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.transactions,"items-per-page":25},scopedSlots:_vm._u([{key:"item.at",fn:function(ref){
var item = ref.item;
return [(item.at)?_c('Time',{attrs:{"time":item.at}}):_vm._e()]}},{key:"item.amount",fn:function(ref){
var item = ref.item;
return [(item.amount)?_c('Currency',{attrs:{"value":item.amount,"cents":""}}):_vm._e()]}},{key:"item.after",fn:function(ref){
var item = ref.item;
return [(item.after)?_c('Currency',{attrs:{"value":item.after,"cents":""}}):_vm._e()]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }